"use strict";

class ChosenAudioeye {
    init() {
        const self = this;

        // 1. Intercept $.fn.chosen initialization (Decorator Pattern)
        const originalChosen = $.fn.chosen;
        if (originalChosen && !$.fn.chosen.isWrapped) {
            $.fn.chosen = function (options) {
                const result = originalChosen.apply(this, arguments);

                // If calling a method (e.g. 'destroy', 'close'), do not re-initialize
                if (typeof options === 'string') {
                    return result;
                }

                this.each(function () {
                    const $select = $(this);
                    const $container = $select.next(".chosen-container");
                    if ($container.length) {
                        self.updateContainerAttributes($container, $select);
                    }
                });

                return result;
            };
            $.fn.chosen.isWrapped = true;
        }

        // 2. Initial run for any statically rendered chosen containers
        this.updateChosenAttributes();
    }

    // Update single container accessibility attributes & event handlers
    updateContainerAttributes($container, $select) {
        const self = this;
        var chosenFocusMoving = false;
        var $listbox = $container.find(".chosen-results");
        var $searchInput = $container.find(".chosen-search-input");

        // Generate unique ID based on select if missing
        var selectId = $select.attr("id") || "select-" + Math.random().toString(36).substring(2, 9);
        if (!$container.attr("id")) {
            $container.attr("id", "chosenContainer-" + selectId);
        }
        if (!$listbox.attr("id")) {
            $listbox.attr("id", "listbox-" + $container.attr("id"));
        }

        // Set baseline ARIA attributes
        $container.attr({
            role: "application",
            "aria-haspopup": "listbox",
            "aria-expanded": "false",
            "aria-controls": $listbox.attr("id"),
            tabindex: "0",
        });

        var labelText = $('label[for="' + $select.attr("id") + '"]')
            .text()
            .trim();
        if (labelText) {
            $container.attr("aria-label", labelText);
        }

        $listbox.attr({
            role: "listbox",
            tabindex: "-1",
        });

        $container.find(".chosen-single").attr({
            "aria-hidden": "true",
            tabindex: "-1",
            role: "presentation",
        });

        $select.attr({
            tabindex: "-1",
            "aria-hidden": "true",
        });

        if ($searchInput.length) {
            $searchInput.removeAttr("aria-hidden");
            $searchInput.attr("tabindex", "-1");
            $searchInput[0].inert = true;
        }

        // Remove previous event handlers to avoid duplicates
        $container.off("keydown.chosen focusin.chosen focusout.chosen");
        $select.off("chosen:showing_dropdown.chosen chosen:hiding_dropdown.chosen");

        // MutationObserver only on chosen-results to track active changes
        var prevObserver = $container.data("chosenObserver");
        if (prevObserver) {
            prevObserver.disconnect();
        }
        if ($listbox.length && window.MutationObserver) {
            var observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (m) {
                    if (
                        (m.type === "childList" && m.addedNodes.length) ||
                        (m.type === "attributes" && m.target.nodeName === "LI")
                    ) {
                        self.refreshChosenOptions($container);
                    }
                });
            });
            observer.observe($listbox[0], {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ["class"],
            });
            $container.data("chosenObserver", observer);
        }

        // Chosen events
        $select.on("chosen:showing_dropdown", function () {
            $container.attr("aria-expanded", "true");
            self.refreshChosenOptions($container);
        });

        $select.on("chosen:hiding_dropdown", function () {
            $container.attr("aria-expanded", "false");

            // Update aria-label with the selected option text so screen reader can read it
            var selectedText = $container
                .find(".chosen-single span")
                .text()
                .trim();
            if (selectedText) {
                $container.attr("aria-label", selectedText);
            }
        });

        // Keyboard events
        $container.on("keydown.chosen", function (e) {
            var key = e.which || e.keyCode;
            var isOpen = $container.hasClass("chosen-with-drop");

            if (key === 13 || key === 32) {
                // Enter / Space
                e.preventDefault();
                if (!isOpen) {
                    $container.find(".chosen-single").trigger("mousedown");
                } else {
                    var $highlighted = $listbox.find("li.highlighted");
                    if ($highlighted.length) {
                        $highlighted.trigger("mouseup");
                    }
                }
                return;
            }

            if (key === 9) {
                // Tab
                if (isOpen) {
                    $select.trigger("chosen:close");
                }
                return;
            }

            if (key === 38 || key === 40) {
                // ArrowUp / ArrowDown
                e.preventDefault();
                if (!isOpen) {
                    return;
                }
                self.moveChosenHighlight($container, key === 40 ? 1 : -1);
                return;
            }

            if (key === 27) {
                // Escape
                e.preventDefault();
                $select.trigger("chosen:close");
                chosenFocusMoving = true;
                setTimeout(function () {
                    chosenFocusMoving = false;
                }, 50);
                setTimeout(function () {
                    $container.focus();
                }, 100);
            }
        });

        // focusin
        $container.on("focusin.chosen", function (e) {
            if (chosenFocusMoving) {
                return;
            }
            $select.trigger("chosen:open");
            $select.trigger("chosen:showing_dropdown");
        });

        // focusout
        $container.on("focusout.chosen", function (e) {
            var $next = $(e.relatedTarget);
            if ($next.closest($container).length) {
                return;
            }
            chosenFocusMoving = true;
            $select.trigger("chosen:close");
            $select.trigger("chosen:hiding_dropdown");
            setTimeout(function () {
                chosenFocusMoving = false;
            }, 50);
        });
    }

    updateChosenAttributes() {
        const self = this;
        $(".chosen-container").each(function () {
            var $container = $(this);
            var $select = $container.prev("select");
            if ($select.length) {
                self.updateContainerAttributes($container, $select);
            }
        });
    }

    refreshChosenOptions($container) {
        var $listbox = $container.find(".chosen-results");
        var $select = $container.prev("select");
        var currentVal = $select.val();

        $listbox.find("li").each(function () {
            var $opt = $(this);

            if (!$opt.attr("id")) {
                $opt.attr("id", $container.attr("id") + "-opt-" + $opt.index());
            }

            var optIdx = $opt.data("option-array-index");
            var optVal =
                optIdx !== undefined
                    ? $select.find("option").eq(optIdx).val()
                    : null;
            var isSelected =
                optVal !== null
                    ? optVal === currentVal
                    : $opt.hasClass("result-selected");

            $opt.attr({
                role: "option",
                "aria-selected": isSelected ? "true" : "false",
                "aria-label": $opt.text().trim(),
            });
        });

        var $highlighted = $listbox.find("li.highlighted");
        if ($highlighted.length) {
            $container.attr("aria-activedescendant", $highlighted.attr("id"));
        } else {
            $container.removeAttr("aria-activedescendant");
        }
    }

    moveChosenHighlight($container, direction) {
        const self = this;
        var $listbox = $container.find(".chosen-results");
        var $opts = $listbox.find(
            "li:not(.group-result):not(.disabled):visible",
        );
        var $current = $listbox.find("li.highlighted");
        var idx = $opts.index($current);
        var next = idx + direction;

        if (next < 0) {
            next = 0;
        }
        if (next >= $opts.length) {
            next = $opts.length - 1;
        }

        $current.removeClass("highlighted");
        var $next = $opts.eq(next);
        $next.addClass("highlighted");

        // scroll into view
        var listScrollTop = $listbox.scrollTop();
        var listHeight = $listbox.innerHeight();
        var optTop = $next.position().top + listScrollTop;
        var optBottom = optTop + $next.outerHeight();

        if (optTop < listScrollTop) {
            $listbox.scrollTop(optTop);
        } else if (optBottom > listScrollTop + listHeight) {
            $listbox.scrollTop(optBottom - listHeight);
        }

        self.refreshChosenOptions($container);
    }
}

const chosenAudioeye = new ChosenAudioeye();
export default chosenAudioeye;
